import { UserAuthTypeEnum } from '../../../../interfaces/user.interface';
import { UserData, UserMapperParams } from './SignUpData.interface';

export const mapToUserData = ({
  signupViaGoogle,
  values,
  selectedPlan,
  couponCode,
  user,
  paymentMethod = null,
  countryCode,
  currency,
}: UserMapperParams): UserData => {
  const email = (signupViaGoogle?.email || values?.email)?.trim()?.toLowerCase();
  return {
    email,
    password: values?.password || '',
    passwordConfirm: values?.confirmPassword || '',
    firstName: signupViaGoogle?.firstName || values?.firstName,
    lastName: signupViaGoogle?.lastName || values?.lastName,
    phoneNumber: values?.phoneNumber,
    authType: signupViaGoogle?.authType || UserAuthTypeEnum.emailPassword,
    plan: signupViaGoogle?.plan || selectedPlan,
    promoCode: couponCode,
    isAdult: values?.confirm || true,
    ...(values.hasOwnProperty('confirm') ? { confirm: !!values.confirm } : {}),
    promotionalEmail: values?.promotionalEmail,
    updateEmail: values?.updateEmail,
    paymentMethod,
    firebaseId: signupViaGoogle?.firebaseId || '',
    ...(values.hasOwnProperty('marketing') ? { marketing: !!values.marketing } : {}),
    ...(user?.acceptedTermsAndConditions && { acceptedTermsAndConditions: user.acceptedTermsAndConditions }),
    ...(countryCode ? { country: countryCode } : {}),
    ...(currency ? { currency } : {}),
    ...(signupViaGoogle?.accessToken ? { accessToken: signupViaGoogle.accessToken } : {}),
  };
};

export const signUpInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  isAdult: false,
  terms: false,
  plan: '',
  promoCode: '',
  updateEmail: false,
  promotionalEmail: false,
};
